<template>
  <div class="header">
    <div class="content">
      <img src="@/assets/logo.png" alt="" class="logo-icon" @click="goHome">
      
      <div class="login-action" v-if="!userInfo || !userInfo.id">
        <div class="header-search-entry" v-if="$route.name !== 'search'" @click="$router.push({name: 'search'})" style="margin-right: 20px;">
          <i class="el-icon-search"></i>
        </div>
        <div class="login-entry" @click="loginAction">
          <img src="@/assets/avatar.png" alt="" class="login-avatar">
          <span class="login-text">登录</span>
        </div>
        <div class="auth-sep"></div>
        <span class="signup-text" @click="signupAction">注册</span>
      </div>
      <div v-else style="margin-left: auto;display: flex;align-items: center;">
        <div class="header-search-entry" v-if="$route.name !== 'search'" @click="$router.push({name: 'search'})" style="margin-right: 20px;">
          <i class="el-icon-search"></i>
        </div>

        <div class="bookshelf-btn" @click="gotoMyBookshelf">
          我的书架
        </div>
        <div style="display: flex;align-items: center;cursor: pointer;margin-left: 20px;" @click="gotoUserSpace">
          <el-image :src="(userInfo && userInfo.avatarUrl) ? userInfo.avatarUrl : require('@/assets/avatar_default.png')" class="avatar_default">
            <div slot="error" class="image-slot" style="width:100%; height:100%; display:flex; align-items:center; justify-content:center;">
              <img :src="require('@/assets/avatar_default.png')" style="width:100%; height:100%; border-radius:50%;" />
            </div>
          </el-image>
          {{ userInfo.nick || userInfo.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {
      searchKeyword: ''
    }
  },
  computed: mapState({
    userInfo: state => state.security.userInfo || {}
  }),
  mounted() {
    this.searchKeyword = this.$route.query.keyword
  },
  methods: {
    loginAction() {
      this.$router.push({ name: 'login' })
    },
    signupAction() {
      this.$router.push({ name: 'signup' })
    },
    goHome() {
      if (this.$route.name != 'homeView') {
        window.location.href = '/'
      }
    },
    gotoUserSpace() {
      if (this.$router.currentRoute.path != '/userspace') {
        this.$router.push({ name: 'userspace', query: { tab: 'accountSetting' } })
      }
    },
    gotoMyBookshelf() {
      if (this.userInfo && this.userInfo.id && this.$route.name !== 'bookshelf') {
        this.$router.push({ name: 'bookshelf' })
      }
    },
    searchBook() {
      console.log(this.searchKeyword)
      const routerName = this.$route.name
      const querykeyword = this.$route.query.keyword
      if (routerName != 'search') {
        this.$router.push({ name: 'search', query: { keyword: this.searchKeyword } })
      } else if (this.searchKeyword != querykeyword) {
        this.$router.replace({ name: 'search', query: { keyword: this.searchKeyword } })
      }
      this.$emit('search', { searchKeyword: this.searchKeyword })
    }
  },
}
</script>

<style lang="less" scoped>
@import '@/styles/layout.less';

.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 60px;

  .content {
    display: flex;
    flex-direction: row;
    align-items: center;
    box-sizing: border-box;
    .page-container();
  }

  .logo-icon {
    cursor: pointer;
    height: 44px;
    width: auto;
    max-width: 300px;
    object-fit: contain;
    margin-right: 40px;
  }

  .header-search-entry {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 50%;
    margin-left: 10px;
    transition: all 0.3s;

    i {
      font-size: 20px;
      color: #0F5EBF;
      font-weight: bold;
    }

    &:hover {
      background-color: rgba(15, 94, 191, 0.08);
      transform: scale(1.1);
    }
  }

  .login-action {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: auto;

    .login-entry {
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: pointer;
      user-select: none;
      transition: opacity 0.2s;

      &:hover {
        opacity: 0.85;
      }

      .login-avatar {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        object-fit: cover;
        flex-shrink: 0;
      }

      .login-text {
        margin-left: 8px;
        font-size: 15px;
        color: #0F5EBF;
        line-height: 1;
      }
    }

    .auth-sep {
      width: 1px;
      height: 14px;
      margin: 0 14px;
      background: #C0C4CC;
      flex-shrink: 0;
    }

    .signup-text {
      font-size: 15px;
      color: #0F5EBF;
      cursor: pointer;
      line-height: 1;
      user-select: none;
      transition: opacity 0.2s;

      &:hover {
        opacity: 0.85;
      }
    }
  }

  /** 挂载在 Header 区域内的头像与书架按钮 */
  ::v-deep .avatar_default {
    height: 30px;
    width: 30px;
    border-radius: 15px;
    margin-right: 10px;
  }

  .bookshelf-btn {
    cursor: pointer;
    padding: 8px 20px;
    line-height: 24px;
    background: #0F5EBF;
    border-radius: 6px;
    color: white;
    font-size: 15px;
    transition: all 0.3s;

    &:hover {
      background: #0d4fa0;
    }
  }

  .tablet-down({
    .logo-icon {
      margin-right: 16px;
      max-width: 220px;
      height: 40px;
    }

    .bookshelf-btn {
      padding: 8px 12px;
      font-size: 14px;
    }

    .login-action .login-entry .login-text,
    .login-action .signup-text {
      font-size: 14px;
    }

    .login-action .auth-sep {
      margin: 0 10px;
    }

    ::v-deep .avatar_default {
      margin-right: 6px;
    }
  });
}
</style>